export default "__VITE_ASSET__m8R6TgWxwop2r_xOIPNRtg__$_?url=true__"